module.exports = __webpack_public_path__ + "img/book.72f03a98.png";